import { Icon, type IconName } from "./Icon";
import "./styles/DevicesSection.css";

interface DevicePoint {
  icon: IconName;
  title: string;
  description: string;
}

const POINTS: DevicePoint[] = [
  { icon: "phone", title: "On your phone or tablet", description: "Add SENfully to your home screen and it opens like any other app. A tablet makes a great board for little hands." },
  { icon: "desktop", title: "On your computer", description: "The same account on a bigger screen, handy for writing a profile or reading a guide before a meeting." },
  { icon: "offline", title: "Even offline", description: "Your child's board keeps talking without the internet, once it has been opened on the device." },
];

export function DevicesSection() {
  return (
    <section className="section devices container" aria-labelledby="devices-title">
      <div className="devices__surface">
        <div className="devices__copy">
          <p className="eyebrow">Anywhere</p>
          <h2 id="devices-title" className="section__title">Right where you are, on any screen</h2>
          <p className="section__lead">No app store and nothing to download. Open SENfully in your browser and it's yours in seconds.</p>

          <ul className="devices__points">
            {POINTS.map((point) => (
              <li key={point.title}>
                <span className="devices__icon"><Icon name={point.icon} size={20} /></span>
                <div>
                  <h3>{point.title}</h3>
                  <p>{point.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="devices__visual">
          <div className="browser-frame">
            <div className="browser-frame__bar" aria-hidden="true"><span /><span /><span /></div>
            <img src="/screens/desktop.jpg" alt="SENfully on a computer, showing the home screen with the side menu" width={1280} height={800} loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </section>
  );
}
